module.exports = __webpack_public_path__ + "static/media/bottomRoller.76c3e078.png";